<template>
  <v-dialog v-model="visible" max-width="500px" :scrim="false">
    <v-card class="d-flex justify-center flex-column py-9">
      <v-card-title class="d-flex justify-space-between align-center">
        <span>{{ title }}</span>
        <v-icon @click="closePopUp" class="close-icon">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <p>{{ $t('modules.admission.exceptions.popup.label') }}</p>
        <v-text-field v-model="email" :error-messages="emailErrors" label="Email" type="email" outlined class="mt-4"
          @keyup.enter="onSearch" append-icon="mdi-magnify" @click:append="onSearch"></v-text-field>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import { $user, $userAra } from '../../Services';

export default {
  name: 'ActionPopUp',
  props: {
    visible: Boolean,
    selectedItem: Object,
    title: String,
    studentCareer: String,

  },
  data() {
    return {
      userId: null,
      email: '',
      showAlert: false
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) {
        errors.push(this.$t('modules.admission.exceptions.validations.emailInput'));
      }
      if (!this.$v.email.email) {
        errors.push(this.$t('modules.admission.exceptions.validations.leadEmailFormat'));
      }
      return errors;
    },
  },
  methods: {
    closePopUp() {
      this.$emit('update:visible', false);
    },
    onSearch() {
      if (!this.$v.email.$invalid) {
        this.getUser(this.email);
      }
    },
    async getUser(userEmail) {
      try {
        const { data } = await $user.find('by-email', null, { params: { email: userEmail } });
        this.userId = data?.length ? data[0].id : null;
        if (!this.userId) {
          this.showAlert = true
          this.visible = false
          this.$store.dispatch('commons/openPopUp', {
            title: this.$t('modules.admission.exceptions.validations.warnings.emailNotFound'),
            content: null,
            actionPrimary: { text: this.$t('actions.confirm'), callback: () => { this.setUserAra(this.userId, this.studentCareer, this.email) } },
            actionSecondary: { text: this.$t('actions.cancel'), callback() { } },
            icon: { color: 'warning', name: 'mdi-eye-off-outline' },
            color: 'primary'
          });
        }
        if (this.userId) {
          this.visible = false
          this.$store.dispatch('commons/openPopUp', {
            title: this.$t('modules.admission.exceptions.validations.success.successEmail'),
            content: null,
            actionPrimary: { text: this.$t('actions.confirm'), callback: () => { this.setUserAra(this.userId, this.studentCareer, this.email) } },
            actionSecondary: { text: this.$t('actions.cancel'), callback() { } },
            icon: { color: 'success', name: 'mdi-check' },
            color: 'primary'
          });
        } else {
          this.showAlert = false
        }
      } catch (error) {
        this.$store.dispatch('commons/openPopUp', {
          title: this.$t('actions.error'),
          content: [{ value: (error.codeMeaning != '') ? error.codeMeaning : this.$t('modules.admission.exceptions.errorMessage.exceptionEmail') }],
          actionPrimary: { text: this.$t('actions.accept'), callback() { } },
          icon: { color: 'error', name: 'mdi-close' },
          color: 'primary'
        });
      }
    },
    async setUserAra(id, studentCareer, userEmail) {
      try {
        const res = await $userAra.create(null , { params: { userId: id, studentCareerId: studentCareer, email: userEmail } })
        if (res) {
        this.$emit('refresh');
        this.$store.dispatch('commons/openPopUp', {
            title: this.$t('modules.admission.exceptions.validations.success.successUserAra'),
            content: null,
            actionPrimary: { text: this.$t('actions.close'), callback() { } },
            icon: { color: 'success', name: 'mdi-check' },
            color: 'primary'
          });
          this.email = ''
        }
      } catch (error) {
        this.$store.dispatch('commons/openPopUp', {
          title: this.$t('actions.error'),
          content: [{ value: (error.codeMeaning != '') ? error.codeMeaning : this.$t('modules.admission.exceptions.errorMessage.exceptionUserAra') }],
          actionPrimary: { text: this.$t('actions.accept'), callback() { } },
          icon: { color: 'error', name: 'mdi-close' },
          color: 'primary'
        });
      }
    },
  },
  watch: {
    email() {
      this.$v.email.$touch();
    },
  }
};
</script>

<style scoped>
.close-icon {
  cursor: pointer;
}
</style>
